export const PROVIDERS = [
  {
    slug: "vtex",
    name: "VTEX",
    type: "platform",
    download: {
      url: "unavailable",
      description:
        "Baixe a tabela de cálculo de frete para integrar na sua plataforma/ERP:",
      button: "Clique aqui para baixar a tabela"
    },
    freightSheet: "sheet",
    hasAuth: true,
    config: {
      status: true,
      matches: true,
      insurance: true,
      tracking: true
    },
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [
      { label: "App Key", key: "appKey" },
      { label: "App Token", key: "appToken" },
      { label: "Account Name", key: "accountName" }
    ],
    faqLink: "https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308946726676-VTEX-Manual-de-Integra%C3%A7%C3%A3o",
    allowMultiplesVolumes: false
  },
  {
    slug: "bling",
    name: "Bling",
    type: "erp",
    setupVideo: "what",
    hasAuth: true,
    config: {
      status: false,
      matches: false,
      insurance: true,
      tracking: true
    },
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [{ label: "API Key", key: "apiKey" }],
    faqLink:
      "https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308962215060-Bling-Integra%C3%A7%C3%A3o-nativa",
    allowMultiplesVolumes: false
  },
  {
    slug: "magento",
    name: "Magento",
    type: "platform",
    download: {
      url:
        "https://bitbucket.org/mandae/magento-calculo-frete/downloads/Mandae_Shipping-1.2.0.tgz",
      description: "Baixe o plugin de cálculo de frete:",
      button: "Clique aqui para baixar o plugin"
    },
    hasAuth: true,
    config: {
      status: true,
      matches: true,
      insurance: true,
      tracking: true
    },
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [
      { label: "Shop Url", key: "shopUrl" },
      { label: "User Name", key: "userName" },
      { label: "API Key", key: "apiKey" }
    ],
    faqLink:
      "https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308973528212-Magento-Manual-de-Integra%C3%A7%C3%A3o",
    allowMultiplesVolumes: false
  },
  // {
  //   slug: 'xtech',
  //   name: 'Xtech',
  //   type: 'platform',
  //   hasAuth: true,
  //   config: null,
  //   description: 'Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê.' +
  //     ' Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.',
  //   fields: [
  //     { label: 'API Key', key: 'apiKey' },
  //     { label: 'App Key', key: 'appKey'},
  //     { label: 'Account Name', key: 'accountName' },
  //   ],
  // },
  // {
  //   slug: 'paypal',
  //   name: 'PayPal',
  //   type: 'platform',
  //   authUrl: '',
  //   hasAuth: true,
  //   config: null,
  //   description: 'Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê.' +
  //     ' Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.',
  // },
  {
    slug: "planilha",
    name: "Planilha",
    type: "manual",
    hasAuth: false,
    config: null
  },
  /* {
    slug: "mercadolivre",
    name: "Mercado Livre",
    type: "platform",
    authUrl: "",
    hasAuth: true,
    config: null,
    description:
      "Importe as suas vendas do Mercado Livre e envie suas encomendas pela Mandaê." +
      " Este serviço tem taxas diferentes do seu plano Mandaê." +
      " Leia atentamente as regras e preços.",
    allowMultiplesVolumes: false
  }, */
  {
    slug: "tray",
    name: "Tray",
    type: "platform",
    hasAuth: true,
    showApiToken: true,
    tutorialSteps: [
      "select-provider",
      "setup-credentials",
      "display-api-token",
      "watch-setup-video",
      "setup-properties"
    ],
    config: {
      status: true,
      matches: true,
      insurance: true,
      tracking: true
    },
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [{ label: "Domínio Loja", key: "dominioLoja" }],
    faqLink:
      "https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308941006996-Tray-Manual-de-Integra%C3%A7%C3%A3o",
    allowMultiplesVolumes: false
  },
  {
    slug: "anymarket",
    name: "ANYMARKET",
    type: "platform",
    hasAuth: true,
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [{ label: "Gumga Token", key: "gumgaToken" }],
    config: {
      status: true,
      matches: true,
      insurance: true,
      tracking: false
    },
    allowMultiplesVolumes: true
  },

  {
    slug: "woocommerce",
    name: "WooCommerce",
    type: "platform",
    hasAuth: true,
    config: {
      status: true,
      matches: true,
      insurance: true,
      tracking: true
    },
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [
      { label: "Consumer Key", key: "consumerKey" },
      { label: "Consumer Secret", key: "consumerSecret" },
      { label: "Shop Url", key: "shopUrl" }
    ],
    allowMultiplesVolumes: false
  },
  {
    slug: "traycorp",
    name: "TraycorpFBITS",
    type: "platform",
    download: {
      url: "unavailable",
      description:
        "Baixe a tabela de cálculo de frete para integrar na sua plataforma/ERP:",
      button: "Clique aqui para baixar a tabela"
    },
    freightSheet: "sheet",
    hasAuth: true,
    config: {
      status: true,
      matches: true,
      insurance: true,
      tracking: true
    },
    description:
      "Importe as vendas da sua conta vendedor e envie as encomendas pela Mandaê." +
      " Os valores deste serviço são os mesmos do seu plano de pagamentos da Mandaê.",
    fields: [{ label: "Token", key: "integrationToken" }],
    faqLink:
      "https://mandae.atlassian.net/wiki/spaces/NTGR/pages/1162674264/TrayCorp+fbits+-+Criar+encomendas",
    allowMultiplesVolumes: false
  },
  {
    slug: "webapp",
    name: "Manual",
    type: "manual",
    hasAuth: false,
    config: null
  },
  {
    slug: "api",
    name: "API Mandaê",
    type: "api",
    hasAuth: false,
    config: null
  }
];
